import { render } from "./your-wallet.vue?vue&type=template&id=f5bd6142"
import script from "./your-wallet.vue?vue&type=script&lang=js"
export * from "./your-wallet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__